export class TransactionEntityFetchFilter {
    id?: number;
    record_id?: number;
    linked_to_kpi?: boolean;
    name?: string;
    category?: string;
    type?: string;
    limit: number = 20.0;
    page: number = 1.0;

    constructor(recordId?: number) {
        if (recordId !== undefined) {
            this.record_id = recordId;
        }
    }

    toQueryParams(): Record<string, string> {
        const params: Record<string, string> = {};
        
        if (this.id !== undefined) {
            params.id = this.id.toString();
        }
        if (this.record_id !== undefined) {
            params.record_id = this.record_id.toString();
        }
        if (this.linked_to_kpi !== undefined) {
            params.linked_to_kpi = this.linked_to_kpi.toString();
        }
        if (this.name) {
            params.name = this.name;
        }
        if (this.category) {
            params.category = this.category;
        }
        if (this.type) {
            params.type = this.type;
        }
        if (this.limit !== undefined) {
            params.limit = this.limit.toString();
        }
        if (this.page !== undefined) {
            params.page = this.page.toString();
        }
        
        return params;
    }
}